import Api from '@/services/Api';

export default {
  updateSensor(request) {
    return Api().patch('/sensors', request);
  },
  calibrateDevice(data) {
    return Api().patch('/sensors/calibrate-device', data);
  },
  calibrateBatchBySensor(data) {
    return Api().patch('/sensors/calibrate-batch-by-sensor', data);
  },
  addCalibrationValue(id, data) {
    return Api().post(`/sensors/${id}/calibration-value`, data);
  },
  removeCalibrationValue(sensorId, rangeId) {
    return Api().delete(`/sensors/${sensorId}/calibration-value/${rangeId}`);
  },
  addCalibrationValueForBatch(id, data) {
    return Api().post(`/sensors/${id}/calibration-value-for-batch`, data);
  },
  removeCalibrationValueFromBatch(batchId, rangeId) {
    return Api().delete(`/sensors/${batchId}/calibration-value-for-batch/${rangeId}`);
  },
};
